import clsx from "clsx"
import { ReactNode } from "react"
import { A } from "src/components/unstyled/A"

export type NpHeaderTextLinkProps = {
  href: string | null | undefined
  children: ReactNode
}

export const NpHeaderTextLink = ({ href, children }: NpHeaderTextLinkProps) => {
  const Element = href ? A : "div"

  return (
    <Element
      href={href || undefined}
      className={clsx("group relative flex h-11 items-center gap-2 rounded-full px-4 font-normal whitespace-nowrap", {
        "hover:text-np-green transition-colors hover:bg-gray-100 hover:transition-none": href,
      })}
    >
      {children}
    </Element>
  )
}
